import { render } from "./telefonoEdit.vue?vue&type=template&id=3a281fc3"
import script from "./telefonoEdit.vue?vue&type=script&lang=ts"
export * from "./telefonoEdit.vue?vue&type=script&lang=ts"
script.render = render

export default script